module.exports = __webpack_public_path__ + "static/media/xls.dfde9de1.svg";